/*LIBRARY*/
import { Component, createRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SPINNER from "../common_spinner/SPINNER";
// import Modal from "../common_modal/Modal";
// import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import {
  gen_action,
  set_value_sini_data,
} from "../../App/actions/sini_data_actions";

/*PICTURE*/

/*FUNCTION*/
import generate_short_uuid from "../../App/validation/generate_short_uuid";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class S_D_TEXT_AREA extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = createRef();
    this.state = {
      title_sini: "",
      token_count: 0,
      selectedItems: [],
      listData: [],
      modal_menu: false,
      menuSelector: ["kirim_csv", "data_resume"],
      menu_list: ["pertahankan_konteks"],
      prevLayerIdActive: [],
      features: [],
      token_awal_setelah_load_csv: 0,
      pertahankan_konteks: false,
      prompt_text: "",
      data_resume: [],
    };
  }
  calculateTokenFromFeatures = () => {
    const { features } = this.state;
    const { geo_layer_list, layer_id } = this.props.layer;
    const { token_open_ai } = this.props.sini_data_reducer;

    const layer = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id,
    )?.geo_layer;

    if (!layer) return;

    const allFields = (layer.fields || []).filter((f) => !f.isStyle);

    if (allFields.length === 0 || features.length === 0) return;

    // Ambil field yang TIDAK disembunyikan oleh SEMUA feature
    const visibleFields = allFields.filter((field) => {
      // Asal SATU feature menunjukkan field ini visible, maka field dianggap visible
      return features.some((feature) => {
        const hidden = feature._hidden || {};
        return !hidden[field.key]; // false atau undefined = visible
      });
    });

    const csv_lines = [];

    // Header row hanya yang visible
    const header_row = visibleFields.map((f) => `"${f.name}"`).join(";");
    csv_lines.push(header_row);

    features.forEach((feature) => {
      const hidden = feature._hidden || {};
      const dataRow = visibleFields
        .map((field) => {
          // Skip field jika disembunyikan
          if (hidden[field.key]) return `""`;

          const val = feature.properties?.[field.key];
          return `"${
            val !== undefined && val !== null
              ? String(val).replace(/"/g, '""')
              : ""
          }"`;
        })
        .join(";");
      csv_lines.push(dataRow);
    });

    const combined_csv_string = csv_lines.join("\n");

    // const csv_lines = [];

    // // Header row hanya yang visible
    // const header_row = visibleFields.map((f) => `"${f.name}"`).join(";");
    // csv_lines.push(header_row);

    // const totals = {}; // Simpan total untuk kolom numerik

    // features.forEach((feature) => {
    //   const hidden = feature._hidden || {};
    //   const dataRow = visibleFields
    //     .map((field) => {
    //       if (hidden[field.key]) return `""`;

    //       const val = feature.properties?.[field.key];
    //       const cleanVal = val !== undefined && val !== null ? val : "";

    //       // Jika nilai numerik, tambahkan ke total
    //       if (typeof cleanVal === "number") {
    //         totals[field.key] = (totals[field.key] || 0) + cleanVal;
    //       } else if (!isNaN(Number(cleanVal)) && cleanVal !== "") {
    //         totals[field.key] = (totals[field.key] || 0) + Number(cleanVal);
    //       }

    //       return `"${String(cleanVal).replace(/"/g, '""')}"`;
    //     })
    //     .join(";");
    //   csv_lines.push(dataRow);
    // });

    // // Tambahkan baris kosong sebagai pemisah
    // csv_lines.push("");
    // const keyToNameMap = Object.fromEntries(
    //   visibleFields.map((f) => [f.key, f.name])
    // );
    // // Tambahkan total_{field} baris per kolom numerik
    // // Tambahkan total berdasarkan nama field
    // Object.entries(totals).forEach(([key, total]) => {
    //   const fieldName = keyToNameMap[key];
    //   csv_lines.push(`total_${fieldName}: "${total}"`);
    // });

    // const combined_csv_string = csv_lines.join("\n");

    const estimated_token_count = Math.ceil(combined_csv_string.length / 4);

    const total = token_open_ai - estimated_token_count;
    const limit_value_resume = 100;
    //buat data resume kalau fields  tipe nya  calculate_  dimension

    const filterData = [
      "simple_referring",
      "calculate_dimension",
      "math_operators",
      "2d_referring",
      "conditional_statement",
      "nilai_pembanding",
      "jarak_apraisal",
      "summary_of_nested_table",
      "table_formula",
      "auto_generate_user_name",
      "capex_value",
    ];

    const filteredFields = allFields.filter((field) =>
      filterData.includes(field.type),
    );

    if (filteredFields.length > 0) {
      const calculateDimensionFields = filteredFields.map((field) => {
        const key = field.key;
        const count_map = {};

        // ── Hitung frekuensi nilai ───────────────────────
        features.forEach((feature) => {
          const value = feature.properties[key];
          if (value != null) {
            count_map[value] = (count_map[value] || 0) + 1;
          }
        });

        const value_resume = Object.entries(count_map)
          .slice(0, limit_value_resume)
          .map(([value, count]) => ({ value, count }));

        // ── Hitung min / max / sum numerik ───────────────
        let min = Infinity;
        let max = -Infinity;
        let sum = 0;
        let hasNumeric = false;

        features.forEach((feature) => {
          const num = Number(feature.properties[key]);
          if (!isNaN(num)) {
            hasNumeric = true;
            min = Math.min(min, num);
            max = Math.max(max, num);
            sum += num;
          }
        });

        return {
          key,
          value_resume,
          min: hasNumeric ? min : null,
          max: hasNumeric ? max : null,
          sum: hasNumeric ? sum : null, // ← atribut baru
        };
      });
      let data_resume = { fileds: calculateDimensionFields };
      this.setState({ data_resume: data_resume });
    } else {
    }

    this.props.set_value_sini_data({
      key: "estimated_token_used",
      value: estimated_token_count,
    });

    this.setState({
      jumlah_token_csv: estimated_token_count,
      token_hemat: total,
      csv_string_single_layer: combined_csv_string,
    });
  };
  componentDidMount() {
    this.calculateTokenFromFeatures();
  }

  componentDidUpdate(prevProps, prevState) {
    const curr = this.props.layer.layer_id_active;
    const prev = this.state.prevLayerIdActive;

    const added = curr.filter((id) => !prev.includes(id));
    const removed = prev.filter((id) => !curr.includes(id));

    const isChanged = added.length > 0 || removed.length > 0;
    let allFeatures = [];

    if (isChanged) {
      const { geo_layer_list, layer_id } = this.props.layer;

      // Ambil semua features dari layer yang aktif
      curr.forEach((layer_id) => {
        const layer = geo_layer_list.find(
          (layer) => layer?.geo_layer?._id === layer_id,
        );
        if (!layer?.geo_layer) return;

        const features = layer.geo_layer.geojson?.features || [];
        allFeatures.push(...features);
      });

      // Ambil fields untuk ditampilkan
      const geo_layer = geo_layer_list.find(
        (item) => item.geo_layer._id === layer_id,
      )?.geo_layer;

      let fields = geo_layer?.fields?.filter((item) => !item.isStyle) || [];

      // Set ke state dulu, baru hitung token
      this.setState(
        {
          prevLayerIdActive: [...curr],
          listData: fields,
          features: allFeatures,
        },
        () => {
          this.calculateTokenFromFeatures();
        },
      );
    }
  }

  on_change_props = (event) => {
    const { max_rows_text_area } = this.props.sini_data_reducer;
    const textarea_line_height = 24;
    const previous_rows = event.target.rows;
    event.target.rows = 1;

    const current_rows = Math.floor(
      event.target.scrollHeight / textarea_line_height,
    );

    if (current_rows === previous_rows) {
      event.target.rows = current_rows;
    }

    if (current_rows >= max_rows_text_area) {
      event.target.rows = max_rows_text_area;
      event.target.scrollTop = event.target.scrollHeight;
    }

    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });

    // this.props.set_value_sini_data({
    //   key: name,
    //   value,
    // });
    this.setState({
      token_count: Math.ceil(value.length / 4),
    });

    if (value.trim() === "") {
      this.props.set_value_sini_data({
        key: "rows_text_area",
        value: 1,
      });
    } else {
      // Update rows based on actual content
      this.props.set_value_sini_data({
        key: "rows_text_area",
        value:
          current_rows < max_rows_text_area ? current_rows : max_rows_text_area,
      });
    }
  };

  on_init_sini_data = () => {
    const { csv_string_single_layer, menuSelector, prompt_text, data_resume } =
      this.state;
    const { layer_id_active, geo_layer_list } = this.props.layer;
    const { geo_project } = this.props.project;
    let { request_id } = this.props.sini_data_reducer;
    request_id = request_id ? request_id : generate_short_uuid();

    this.props.set_value_sini_data({
      key: "request_id",
      value: request_id,
    });

    const layer_name_list = layer_id_active.map((layer_id) => {
      const layer_name = geo_layer_list.find(
        (layer) => layer?.geo_layer?._id === layer_id,
      )?.geo_layer?.name;
      return layer_name;
    });
    const layer_type_list = layer_id_active.map((layer_id) => {
      const layer_type = geo_layer_list.find(
        (layer) => layer?.geo_layer?._id === layer_id,
      )?.geo_layer?.type;
      return layer_type;
    });

    const layer_data_csv = [csv_string_single_layer || ""];

    if (prompt_text !== "") {
      const body = {
        request_id: request_id,
        project_id: geo_project._id,
        prompt_text,
        layer_name_list,
        layer_id_list: layer_id_active,
        layer_type_list,
        layer_data_csv,
        settings: menuSelector,
        data_resume_fe: data_resume,
      };
      this.props.gen_action(body);
    }

    // this.props.set_value_sini_data({
    //   key: "prompt_text",
    //   value: "",
    // });
    this.setState({ prompt_text: "" });
    this.props.set_value_sini_data({
      key: "rows_text_area",
      value: 1,
    });
  };
  toggleItem = (item) => {
    const { selectedItems, features } = this.state;
    const isSelected = selectedItems.includes(item);

    const updatedItems = isSelected
      ? selectedItems.filter((val) => val !== item)
      : [...selectedItems, item];

    const updatedFeatures = features.map((feature) => {
      const newFeature = { ...feature, properties: { ...feature.properties } };

      if (!newFeature._hidden) newFeature._hidden = {}; // simpan status hidden per key

      if (item?.key in newFeature._hidden) {
        newFeature._hidden[item.key] = !newFeature._hidden[item.key];
      } else {
        newFeature._hidden[item.key] = true;
      }

      return newFeature;
    });

    this.setState(
      {
        selectedItems: updatedItems,
        features: updatedFeatures,
      },
      () => {
        this.calculateTokenFromFeatures();
      },
    );
  };

  toggle_menu = () => {
    this.setState((prevState) => ({
      modal_menu: !prevState.modal_menu,
    }));
  };

  toggleAllItems = () => {
    const { selectedItems, features, listData } = this.state;

    const isAllSelected = selectedItems.length === listData.length;

    const updatedItems = isAllSelected ? [] : [...listData];

    const updatedFeatures = features.map((feature) => {
      const newFeature = { ...feature, properties: { ...feature.properties } };
      if (!newFeature._hidden) newFeature._hidden = {};

      listData.forEach((item) => {
        newFeature._hidden[item.key] = !isAllSelected;
      });

      return newFeature;
    });

    this.setState(
      {
        selectedItems: updatedItems,
        features: updatedFeatures,
      },
      () => {
        this.calculateTokenFromFeatures();
      },
    );
    // this.setState(
    //   (prev) => {
    //     const { selectedItems, features, listData } = prev;
    //     const isAllSelected = selectedItems.length === listData.length;

    //     const updatedItems = isAllSelected ? [] : [...listData];

    //     const updatedFeatures = features.map((f) => {
    //       const nf = { ...f, properties: { ...f.properties } };
    //       nf._hidden = { ...(f._hidden ?? {}) };

    //       listData.forEach((it) => {
    //         nf._hidden[it.key] = !isAllSelected;
    //       });
    //       return nf;
    //     });

    //     return {
    //       selectedItems: updatedItems,
    //       features: updatedFeatures,
    //     };
    //   },
    //   () => {
    //     this.calculateTokenFromFeatures();
    //   }
    // );
  };
  setmenuSelector = (dt) => {
    this.setState((prev) => {
      const sudahAda = prev.menuSelector.includes(dt);

      return {
        menuSelector: sudahAda
          ? prev.menuSelector.filter((item) => item !== dt) // take‑out
          : [...prev.menuSelector, dt], // push
      };
    });
  };

  render() {
    //local storage
    const language =
      localStorage?.language || this.props.auth.language || "ina";

    //local state
    const { listData, menuSelector, prompt_text } = this.state;

    //global props
    const { loading_item_array } = this.props.loading_reducer;
    const { rows_text_area } = this.props.sini_data_reducer;

    //content
    const content_menu = menuSelector.includes("edit_fields") && (
      <div
        id="custom_selection_list"
        style={{
          position: "absolute",

          left: 0,
          width: 240,
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,.15)",
          maxHeight: "40vh",
          overflowY: "auto",
          zIndex: 9999,
          top: "auto",
          bottom: "calc(100% + 8px)",
        }}
      >
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <button
                  onClick={this.toggleAllItems}
                  className={
                    this.state.selectedItems.length === listData.length
                      ? "checklist_not"
                      : "checklist_active"
                  }
                />
              </td>
              <td onClick={this.toggleAllItems} className="side">
                {dict?.["All"]?.[language] || "All"}
              </td>
            </tr>

            {listData?.map((item, idx) => {
              const isActive = this.state.selectedItems.includes(item);
              return (
                <tr key={idx}>
                  <td>
                    <button
                      onClick={() => this.toggleItem(item)}
                      className={
                        isActive ? "checklist_not" : "checklist_active"
                      }
                    />
                  </td>
                  <td onClick={() => this.toggleItem(item)} className="side">
                    {item.name}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );

    return (
      <main>
        <textarea
          placeholder={
            dict?.["Create graphs, legends, data insights"]?.[language]
          }
          rows={rows_text_area}
          className="margin_bottom"
          value={prompt_text}
          name="prompt_text"
          onChange={this.on_change_props}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              this.on_init_sini_data();
            }
          }}
          style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
        />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "16px",
              }}
            >
              <button
                onClick={() => this.setmenuSelector("pertahankan_konteks")}
                className={`button_big 
                  "background_grey_light"
                `}
                title={
                  dict?.[
                    "Maintain context in chats so that AI remembers previous conversations."
                  ]?.[language]
                }
              >
                <span
                  className={
                    menuSelector.includes("pertahankan_konteks")
                      ? "checklist_active"
                      : "checklist_not"
                  }
                  style={{ marginRight: "10px" }}
                />

                {dict?.["Maintain Context"]?.[language]}
              </button>
            </div>

            {/* Konten Menu */}
            <div style={{ marginTop: "20px" }}>{content_menu}</div>

            {/* <FLOAT_MENU
              anchorEl={this.buttonRef.current}
              open={this.state.modal_menu}
              onClose={() => {
                this.toggle_menu();
              }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              style={{ borderRadius: "15px" }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: 20 }}
              >
                {menu_list.map((dt) => (
                  <button
                    className={
                      dt === "edit_fields" && "button_big background_grey "
                    }
                    key={dt}
                    onClick={() => this.setmenuSelector(dt)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    {dt === "edit_fields" &&
                      estimated_token_used > token_open_ai && (
                        <span
                          style={{
                            backgroundColor: "red",
                            color: "white",
                            borderRadius: "50%",
                            width: 16,
                            height: 16,
                            fontSize: 12,

                            fontWeight: "bold",
                          }}
                        >
                          !
                        </span>
                      )}
                    {dt !== "edit_fields" && (
                      <span
                        className={
                          menuSelector.includes(dt)
                            ? "checklist_active"
                            : "checklist_not"
                        }
                      />
                    )}

                    {dt}
                  </button>
                ))}
                {content_menu}
              </div>
            </FLOAT_MENU> */}
          </div>
          {loading_item_array.includes("gen_action") ? (
            <button className="button_big background_black margin_bottom">
              {dict?.["Sending"]?.[language]}{" "}
              <SPINNER
                unik="ai_spinner"
                width={10}
                border={0.25}
                color1="white"
                color2="#28a3f5"
              />
            </button>
          ) : (
            <button
              className="button_big background_black margin_bottom"
              onClick={this.on_init_sini_data}
            >
              {dict?.["Send"]?.[language]}
            </button>
          )}
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, { set_value_sini_data, gen_action })(
  S_D_TEXT_AREA,
);
